const state = {
}
const	getters = {
}
const	mutations = {
}
const	actions = {

  reqActivityFlowWay({commit},params){
    return new Promise((r, j) => {
      fetch({
        url: "hcm/cus/selectbmcSetting",
        method: "get",
        // params:params
      }).then((res) => {
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
